import type { MarketConfiguration } from "./const";
import {
  ContentfulEnum,
  CurrencyEnum,
  ElevateMarketEnum,
  LocaleEnum,
  MarketEnum,
  RegionEnum,
  ServiceLocaleEnum,
} from "./const";

const slovenia: MarketConfiguration = {
  code: MarketEnum.si,
  label: "Slovenia",
  descriptiveLabel: "Slovenian",
  contentfulLocale: ContentfulEnum.en,
  contentfulCountry: "Slovenia",
  locale: LocaleEnum.si,
  serviceLocale: ServiceLocaleEnum.si,
  language: {
    code: "en",
    label: "English",
    flag: "gb",
  },
  currency: CurrencyEnum.eur,
  link: "https://www.no-ga.com/en-si",
  termsSlug: "terms-online",
  loop54Market: MarketEnum.si,
  adyenMarket: MarketEnum.si,
  elevateMarket: ElevateMarketEnum.eu,
  freeShippingEnabled: false,
  freeShippingThreshold: 100,
  externalStoreId: "ecom-noga",
  searchPathName: "search",
  adyenCheckoutEnabled: true,
  walleyCheckoutEnabled: false,
  hasTrustPilot: false,
  region: RegionEnum.europe,
  norceImageCdn: ["local", "dev", "stage"].includes(
    process.env.NEXT_PUBLIC_ENVIRONMENT ?? "",
  )
    ? "https://media.stage.cdn-norce.tech/1413"
    : "https://cdn.no-ga.com",
};

export default slovenia;
